import { Trans } from '@lingui/macro';
import React from 'react';
import { debug } from '~/utilities/logger';
import { ErrorBoundaryErrorInfo, ErrorBoundaryProps, ErrorBoundaryState } from './types';

export const DefaultErrorView: React.FC<ErrorBoundaryState> = () => (
  <h1>
    <Trans>Something went wrong.</Trans>
  </h1>
);

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = {
      error: undefined,
    };
  }

  public static getDerivedStateFromError(error: Error) {
    return { error };
  }

  public componentDidCatch(error: Error, info: ErrorBoundaryErrorInfo) {
    debug.info(info.componentStack);

    debug.info('componentDidCatch');

    debug.error(error);

    this.setState({
      error,
    });

    // TODO: Log error to third party service.
  }

  public render() {
    const { error } = this.state;
    const { children, component } = this.props;

    if (error) {
      if (component) {
        return React.createElement(component, { error });
      }

      return <DefaultErrorView error={error} />;
    }

    return children;
  }
}
